export default "__VITE_ASSET__CQ7OGVBU__"